import clsx from 'clsx';
import { Dispatch, ReactNode, SetStateAction, forwardRef } from 'react';
import { MenuConfig } from 'alurkerja-ui';
import ListMenu from './ListMenu';

export interface SidebarProps {
  logo: ReactNode;
  workspace?: ReactNode;
  menuConfig: MenuConfig[];
  toggled: boolean;
  setToggled: Dispatch<SetStateAction<boolean>>;
  width?: string | number;
  currentPathName?: string;
  className?: string;
  menuWrapper?: ({
    children,
    menu,
    toggled,
  }: {
    children: JSX.Element;
    menu: MenuConfig;
    toggled: boolean;
  }) => JSX.Element;
}

const Sidebar = forwardRef<HTMLDivElement, SidebarProps>((props, ref) => {
  const { logo, workspace, menuConfig, toggled, className, currentPathName, menuWrapper, ...rest } = props;

  return (
    <div
      className={clsx(
        'h-[calc(100vh-4rem)] z-50 top-0 transition-[width,margin] border-r ease-in-out duration-400 bg-[#FAFAFA] dark:bg-gray-900 dark:border-gray-700 relative flex flex-col',
        !toggled ? 'w-60' : '-ml-60 md:ml-0 md:w-20',
        className,
      )}
      ref={ref}
      {...rest}
    >
      {/* Workspace selector */}
      {!toggled && workspace && (
        <div className="px-4 pt-4 pb-3">
          {workspace}
          <div className="w-full border-t border-gray-200 dark:border-gray-700 mt-3" />
        </div>
      )}

      {/* Menu */}
      <div className="flex-1 overflow-y-auto pb-4 scrollbar-thin scrollbar-track-[#FAFAFA] dark:scrollbar-track-gray-900 scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600 scrollbar-thumb-rounded scrollbar-track-rounded">
        <ListMenu
          menuConfig={menuConfig}
          toggled={toggled}
          currentPathName={currentPathName}
          menuWrapper={menuWrapper}
        />
      </div>
    </div>
  );
});

export default Sidebar;
